import styled from 'styled-components';

export const StyledWithdrawnMedicineField = styled.div`
   display: grid;
   grid-template-columns: 1fr 70px 200px 24px;
   gap: 32px;
   align-items: center;
`;
